import { ChangeEventHandler } from 'react';
import Input from '../Input/Input';
import { ReactComponent as SearchIcon } from '../../icons/search.svg';
import { ReactComponent as CrossIcon } from '../../icons/close.svg';
import './SearchInput.scss';
import Button from '../Button';

interface Props {
  onChange: (v: string) => void;
  value: string;
  className?: string;
  placeholder: string;
  name?: string;
}

export default function SearchInput({
  onChange,
  value,
  name,
  className = '',
  placeholder,
}: Props) {
  const onCrossClick = () => {
    onChange('');
  };

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={`SearchInput position-relative ${className}`}>
      <Button
        styling='naked'
        className='SearchInput__btn SearchInput__searchBtn position-absolute'
      >
        <SearchIcon />
      </Button>
      <Input
        name={name}
        onChange={handleChange}
        value={value}
        className='Input--SearchInput'
        placeholder={placeholder}
      />
      {value && (
        <Button
          styling='naked'
          className='SearchInput__btn SearchInput__crossBtn position-absolute'
          onClick={onCrossClick}
        >
          <CrossIcon />
        </Button>
      )}
    </div>
  );
}
